export const currencyList = ['USD', 'EUR', 'NIS', 'GBP', 'CHF', 'CAD', 'AUD'];
